import React from 'react';
import { Site } from '../../lib/Site';
import NavigationDropdownItem from '../TopLevelNav/TopLevelNavigationDetachedDropdownItem';
import SupportMenu from './SupportMenu';

interface Props {
    site: Site;
}

export default function StaticSupportNavigationDropdownItem({ site }: Props) {
    return (
        <NavigationDropdownItem
            additionalClasses={['top-level-nav__item--support']}
            label={__('Support')}
            url="/help"
            location="down-right"
        >
            <SupportMenu site={site} />
        </NavigationDropdownItem>
    );
}
